import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { VERIFY_EMAIL_URL } from '../Api'
import ErrorWindow from '../Indicators/ErrorWindow'
import LoadingIndicator from '../Indicators/LoadingIndicator'
import RedirectCountdownToLogin from './RedirectCountdownToLogin'

const VerifyLinkHandler = () => {
    const { code } = useParams()
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(undefined)
    const [redirectCountdown, setRedirectCountdown] = useState(false)

    const verify = useCallback(() => {
        setSubmitting(true)
        fetch(`${VERIFY_EMAIL_URL}?code=${code}`)
        .then(response=>{
            if(response.ok) {
                setSubmitting(false)
                setRedirectCountdown(true)
            } else {
                const err = new Error("Something went wrong...")
                err.response = response
                throw err
            }
        })
        .catch(err=>{
            const onUnexpectedError = () => {
                setSubmitting(false)
                setError("Something went wrong. Please check your internet connection and try again!")
            }
            if(err.response !== undefined && (err.response.status === 409 || err.response.status === 406 || err.response.status === 400)) {
                err.response.json()
                .then((json)=>{
                    setSubmitting(false)
                    setError(json.status)
                })
                .catch(()=>{
                    onUnexpectedError()
                })
            } else {
                onUnexpectedError()
            }
        })
    }, [code])

    useEffect(()=>{
        verify()
    }, [verify])
    if(submitting) {
        return(<LoadingIndicator message={"Verifying..."}/>)
    } else if(error) {
        return(<ErrorWindow message={error} continue={undefined}/>)
    } else if(redirectCountdown) {
        return(<RedirectCountdownToLogin/>)
    } else {
        return(<div className="verifyLinkHandler">
            We will begin verifying your email shortly.
        </div>)
    }
}

export default VerifyLinkHandler
